<template>
  <v-runtime-template :template="gridItem"></v-runtime-template>
</template>

<script>
import { mapState } from 'vuex'
import VRuntimeTemplate from 'v-runtime-template'
import HitItem from '@/mixins/hitItem.js'

export default {
  components: {
    VRuntimeTemplate
  },
  mixins: [HitItem],
  computed: {
    ...mapState('search', ['gridItem'])
  }
}
</script>
